"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HelpTipContent = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _loadStyles = _interopRequireDefault(require("load-styles"));

(0, _loadStyles.default)(".ca656953a{display:block}.c1f186f42{text-align:center;font-size:1rem;font-weight:500;line-height:1.125rem;margin-top:.3125rem;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;color:var(--color-flomni-green-70)}.c65c9ea13{text-align:center;font-size:1rem;font-weight:400;line-height:1.125rem;margin-top:1.3125rem;overflow:hidden;position:relative;height:3.6em;margin-bottom:1.125rem}");
var styles = {
  root: 'ca656953a',
  title: 'c1f186f42',
  body: 'c65c9ea13'
};

var HelpTipContent = function HelpTipContent(props) {
  var title = props.title,
      children = props.children,
      classes = props.classes;
  var cn = (0, _useStyles.useStyles)(styles, classes);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: cn.root
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cn.title
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    className: cn.body
  }, children));
};

exports.HelpTipContent = HelpTipContent;
HelpTipContent.propTypes = {
  /* component logic props */
  title: _propTypes.string.isRequired,
  children: _propTypes.node.isRequired,

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
HelpTipContent.defaultProps = {
  classes: {}
};